import { Component, OnInit } from '@angular/core';
import { MasterService,ClassroomService } from '../../services/index';

import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-smsmarks',
  templateUrl: './smsmarks.component.html',
  styleUrls: ['./smsmarks.component.scss'],
  providers:[MasterService,ClassroomService]
})
export class SmsmarksComponent implements OnInit {

  memberdetails:any[]=[];
  classdetails:any[]=[];
  arrashead:any=[];
  arrastype:any=[];
  closeResult: string;
  classes: any=[];
  section: any=[];
  arrcourse:any=[];
  arrsubcomb:any=[];
  student:boolean=true;
  staff:boolean=false;
  memberdash:any={};
  objass:any={};
  objupload:any={};
  objfilt:any={};
  objfilt1:any={};
  arreval:any=[];
  arrevpatern:any=[];
  showload="no";
  arrevpatern1:any=[];
  arrcat:any=[{name:'Board'},{name:'Competitive'}];
  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;
  fileToUpload: File = null;

fData: FormData = new FormData;

  constructor(private http: HttpClient, private cservice: ClassroomService, private mservice: MasterService,private modalService: NgbModal) { }

  ngOnInit(): void {

    this.masasshead();
    this.masasstype();

  }


  
  
  masasshead() {
    this.mservice.sel_sp_masasshead()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.arrashead = resultArray;
            this.objfilt.asid=resultArray[0].asid;
            this.objfilt1.asid=resultArray[0].asid;
           // this.fmodel.assid=resultArray[0].asid;
           this.masasstype();
        },
        error => console.log("Error :: " + error)
        )
  }
  masasstype() {
    this.mservice.sel_sp_masasstype()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.arrastype = resultArray;
            this.objfilt.astpid=resultArray[0].astpid;
            this.objfilt1.astpid=resultArray[0].astpid;
            this.getevpatternbyclass();
           // this.fmodel.asstypeId=resultArray[0].astpid;
        },
        error => console.log("Error :: " + error)
        )
  }

  getstudentlist(clid,scid) {

    console.log('objfilt',this.objfilt1);
    var pst={clid:clid,scid:scid};
    //var pst={clid:clid,crid:crid,sucbid:sucbid,asid:asid,astpid:astpid};
    this.cservice.getstuinfoformarkssms(pst)
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.arrevpatern = resultArray;
           // this.fmodel.asstypeId=resultArray[0].astpid;
        },
        error => console.log("Error :: " + error)
        )
  }

  getevpatternbyclass() {

    console.log('objfilt',this.objfilt1);
    //var pst={clid:clid,crid:crid,sucbid:sucbid,asid:asid,astpid:astpid};
    this.cservice.sel_evaluationentry(this.objfilt1.asid,this.objfilt1.astpid,"selectcnt")
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.arrevpatern1 = resultArray;
           // this.fmodel.asstypeId=resultArray[0].astpid;
        },
        error => console.log("Error :: " + error)
        )
  }

  


 

   selectedAll: any=false;
   selectAll() {
       for (var i = 0; i < this.arrevpatern.length; i++) {
         this.arrevpatern[i].selected = this.selectedAll;
       }
     }
     checkIfAllSelected() {
       this.selectedAll = this.arrevpatern.every(function(item:any) {
           return item.selected == true;
         })
     }

     sendmarks()
     {
      this.showload="yes";
       var stulst=this.arrevpatern.filter(item => item.selected===true);

       console.log('assid1',this.arrevpatern);
       console.log('assid2',stulst);
      // console.log('assid',this.asmtid);
       var postdata={asid:this.objfilt1.asid,astpid:this.objfilt1.astpid,stulst:stulst};
   
       this.cservice.sendmarkssms(postdata)
       .subscribe(
       resultArray => {
           console.log('stulst', resultArray);
           alert(resultArray.message);
           this.showload="no";
           
          
       },
       error =>{ console.log("Error :: " + JSON.stringify(error));
       alert("Error in sending sms");
       this.showload="no";}
       )
     }
   openinfo(content,clid,scid)
   {
    
    this.objupload.clid=clid;
    this.objupload.scid=scid;
    this.objupload.asid=this.objfilt1.asid;
    this.objupload.astpid=this.objfilt1.astpid;
    this.getstudentlist(clid,scid);
   
     this.modalOptions = {
       backdrop:'static',
       backdropClass:'customBackdrop',
       size:'lg'
      }
     this.modalRef=this.modalService.open(content,this.modalOptions);
     
     this.modalRef.result.then((result) => {
    
          // this.Asmtdetls(asid);
           //this.closeResult = `Closed with: ${result}`;
       }, (reason) => {
           //this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
       });
   }
   

   upload(files: FileList) {
    debugger;
    this.fileToUpload = files.item(0);
  
   
  }
  
  
 
  fileupload()
  {
  debugger
  
  console.log('file data',JSON.stringify(this.fileToUpload));
  
  this.cservice.uploadphoto(this.fileToUpload,this.objupload)
  .subscribe(fresult => {
     // console.log('ret',JSON.stringify(fresult));
      alert (fresult.message);
      if(fresult.status=='Success')
  {
  // let localmodref=this.modalRef;
  // localmodref.close();
  //this.Refreshsummary();
  this.fileToUpload=null;
  // this.dcid=0;
  // this.disuploadbtn=true;
  // this.photo=fresult.updfilepath;
  
  }
      
  }, error => 
  alert('error in connection')
  
  );
  
  
  
  }
      

}
